import React from 'react';

import styled from 'styled-components';

import { useWidgetContext } from './WidgetContext';
import AIInsightsWidgetContent from '../AIInsights/AIInsightsWidgetContent';
import AmenitiesWidgetContent from '../Amenities/AmenitiesWidgetContent';
import CardWidgetContent from '../CardWidget/CardWidgetContent';
import { GRAPH_WIDGET_TYPES, SINGLE_METRIC_WIDGET_TYPES, WIDGET_TYPES } from '../constants';
import ContractBenefits from '../ContractBenefits/ContractBenefits';
import GraphWidgetContent from '../GraphWidget/GraphWidgetContent';
import IncentivesWidgetContent from '../Incentives/IncentivesWidgetContent';
import MapWidgetContent from '../Map/MapWidgetContent';
import MarketPositioningWidgetContent from '../MarketPositioning/MarketPositioningWidget';
import PhotosWidgetContent from '../Photos/PhotosWidgetContent';
import PricingComparisonWidgetContent from '../PricingComparison/PricingComparisonWidgetContent';
import ReviewsWidgetContent from '../Reviews/ReviewsWidgetContent';
import ReviewsSummaryWidgetContent from '../ReviewsSummary/ReviewsSummaryWidgetContent';
import SwotPerformanceWidgetContent from '../Swot/SwotPerformanceWidgetContent';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  flex-grow: 1;
  height: 100%;
  overflow: auto;
`;

const WidgetContent = () => {
  const { type } = useWidgetContext();

  return (
    <Container className="mini-scroll">
      {SINGLE_METRIC_WIDGET_TYPES.includes(type) && <CardWidgetContent />}
      {GRAPH_WIDGET_TYPES.includes(type) && type !== WIDGET_TYPES.MARKET_POSITIONING && <GraphWidgetContent />}
      {WIDGET_TYPES.MARKET_POSITIONING === type && <MarketPositioningWidgetContent />}
      {WIDGET_TYPES.REVIEWS === type && <ReviewsWidgetContent />}
      {WIDGET_TYPES.REVIEWS_SUMMARY === type && <ReviewsSummaryWidgetContent />}
      {WIDGET_TYPES.INCENTIVES === type && <IncentivesWidgetContent />}
      {WIDGET_TYPES.PHOTOS === type && <PhotosWidgetContent />}
      {WIDGET_TYPES.SWOT_PERFORMANCE === type && <SwotPerformanceWidgetContent />}
      {WIDGET_TYPES.MAP === type && <MapWidgetContent />}
      {WIDGET_TYPES.AMENITIES === type && <AmenitiesWidgetContent />}
      {WIDGET_TYPES.CONTRACT_BENEFITS === type && <ContractBenefits />}
      {WIDGET_TYPES.PRICING_COMPARISON === type && <PricingComparisonWidgetContent />}
      {WIDGET_TYPES.AI_INSIGHTS === type && <AIInsightsWidgetContent />}
    </Container>
  );
};

export default WidgetContent;
